import { memo, useState } from 'react';
import ROUTES from '../../../constants/routes';
import { Container, Image, Nav, Navbar } from 'react-bootstrap';
import { isObjectNotEmpty } from '../../../utils/objectUtils';
import Logo from '../../../assets/images/RX_Logo_Black.png';
import QuickMenu from '../../QuickMenu';
import { Link, NavLink, useSearchParams } from 'react-router';
import { useAuth } from '../../../redux/ducks/auth';

const NavbarHomeLanding = (props) => {
    //#region useSearchParams

    const [searchParams, setSearchParams] = useSearchParams();

    //#endregion
    //#region useStates

    const [expandedMenu, setExpandedMenu] = useState(false);

    //#endregion
    //#region useAuth

    const { authContext } = useAuth();

    //#endregion

    return (
        <>
            <Navbar
                onToggle={(collapsed) => setExpandedMenu(collapsed)}
                expanded={expandedMenu}
                expand="xs"
                className="navbar-default"
            >
                <Container fluid>
                    <Navbar.Brand as={Link} to={{ pathname: ROUTES.HOME, search: searchParams.toString() }}>
                        <Image src={Logo} alt="" loading="lazy" style={{ height: 30 }} />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbar-default">
                        <span className="icon-bar top-bar mt-0"></span>
                        <span className="icon-bar middle-bar"></span>
                        <span className="icon-bar bottom-bar"></span>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="navbar-default">
                        <Nav className="ms-auto">
                            <div className="ms-6 mt-3 mt-lg-0">
                                <div className="d-flex align-items-center">
                                    {isObjectNotEmpty(authContext.currentAuthUser) ? (
                                        <>
                                            <Nav className="ms-auto">
                                                <QuickMenu />
                                            </Nav>
                                        </>
                                    ) : (
                                        <div className="ms-auto d-flex flex-row">
                                            <Nav>
                                                <NavLink to={{ pathname: ROUTES.SIGN_IN, search: searchParams.toString() }}>Sign In</NavLink>
                                            </Nav>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <span className={`ms-auto mt-3 mt-lg-0`}></span>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default memo(NavbarHomeLanding);